/**
 * Directive: auditTrail
 */
angular.module('acme.common.directive.auditTrail', [
  'acme.common.service.helpers',
  'acme.common.service.auditTrail',
  'acme.common.service.api',
  'acme.common.service.userPreferences',
  'agGrid'
])
.directive('auditTrail', ['$timeout', 'ApiService', 'HelpersService', 'AuditTrailService', 'UserPreferencesService', function($timeout, ApiService, HelpersService, AuditTrailService, UserPreferencesService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/auditTrail/auditTrail.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        
        $scope.$on('auditTrail::modelLoaded', modelLoaded);

        function modelLoaded() {
          angular.element('.audit-trail-container').on('mouseenter', function() { 
            angular.element(this).find('.fa-circle').addClass('audit-trail-dot-indent');
            angular.element(this).find('.audit-trail-container-content').addClass('audit-trail-border-indent');
            }
          );
          angular.element('.audit-trail-container').on('mouseleave', function() { 
            angular.element(this).find('.fa-circle').removeClass('audit-trail-dot-indent');
            angular.element(this).find('.audit-trail-container-content').removeClass('audit-trail-border-indent');
          });
        }
        
      },

      controller: ['$scope', function($scope) {

        $scope.auditTrail = {
          
          model : {},
          isVisible: false,
          gridOptions: [],
          path: '',
          
          init: function () {
            $scope.auditTrail.dateTimeFormat = UserPreferencesService.getDateTimeFormat('shortDateTime');
            $scope.$on('history::auditTrail', this.showAuditTrail);
            $scope.$on('$destroy', $scope.auditTrail.onDestroy);
          },
          
          onDestroy: function () {
            $scope.$emit('auditTrail::backToHistory', true);
            AuditTrailService.resetVersionModel();
          },

          showAuditTrail: function (e, trail) {
            var self = $scope.auditTrail;
            self.isVisible = trail.isVisible;
            self.path = trail.path;
            self.loadAuditTrail();
          },
          
          loadAuditTrail: function () {
            var self = $scope.auditTrail;
            self.model = AuditTrailService.getVersionModel();
            if(!self.model.isEmpty) {              
              $timeout(function () {
                self.setDataRowForGrid();
                $scope.$broadcast('auditTrail::modelLoaded');
              },100);
            }
          },
          
          setDataRowForGrid: function () {
            var i, ii,
                options,
                self =  $scope.auditTrail;
                
            for (i=0,ii=self.model.gridOptions.length;i<ii; i++) {
              options = self.model.gridOptions[i];
              
              if(self.model.grids[i].updated.length && self.model.grids[i].original.length) {
                options.api.setRowData(self.model.grids[i].updated);
              } else if (self.model.grids[i].newValues.length) {
                options.api.setRowData(self.model.grids[i].newValues);
              } else if (self.model.grids[i].removed.length) {
                options.api.setRowData(self.model.grids[i].removed);
              }
              options.instance = self.model.grids[i];
              options.isLoaded = true;
              self.timeOutResize(options);
            }
          },
          
          timeOutResize: function (options) {
            $timeout(function () {
              options.api.sizeColumnsToFit();
            });
          },
          
          changeGridModel: function (grid, idx, state) {
            var self =  $scope.auditTrail;
            self.model.gridOptions[idx].api.setRowData(grid.instance[state]);
            self.model.gridOptions[idx].api.refreshView();
            grid.instance.flags.isPrevious = !grid.instance.flags.isPrevious;
          },
          
          backToHistory: function () {
            this.isVisible = false;
            AuditTrailService.resetVersionModel();
            $scope.$emit('auditTrail::backToHistory', true);
          },
          
          nextVersion: function () {
            var self = $scope.auditTrail;
            if(self.model.nextVersion !== null) {
              ApiService.history.auditTrail.list(self.model.nextVersion.version, AuditTrailService.ID, self.path).then(self.success.setVersionModel, self.error.setVersionModel);
            }
          },
          
          previousVersion: function () {
            var self = $scope.auditTrail, version;
            if(self.model.previousVersion !== null) {
              ApiService.history.auditTrail.list(self.model.previousVersion.version, AuditTrailService.ID, self.path).then(self.success.setVersionModel, self.error.setVersionModel);
            }
          },
          
          success: {
            setVersionModel: function (res) {
              var self = $scope.auditTrail;
              AuditTrailService.resetVersionModel();
              AuditTrailService.setVersionModel(res.data.payload);
              self.loadAuditTrail();
            }
          },
          
          error: {
            setVersionModel: function (res) {
              
            }
          }
          
        };
        
        $scope.auditTrail.init();
        
      }]
    };
}]);